var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-subject"},[_c('ed-layout-basic',{attrs:{"footer":false}},[_c('ed-create-product',{attrs:{"initFormData":_vm.course,"elementId":_vm.courseId,"saving":_vm.saving,"title":_vm.title}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }